import dddLogo from "../../assets/logo.svg";
import eLogo from "../../assets/evropalogobel.webp";
import classes from "./Logo.module.scss";
import { OrgIdContext, Domain } from "../../store/orgId_context";
import { useContext } from "react";
import { ThemeContext } from "../../store/ThemeContext";

const Logo = () => {
  const {logo, preview} = useContext(ThemeContext);
  const {sessionInfo, domain} = useContext(OrgIdContext);
  return (<>
      {(domain===Domain.DDDInvoices) && !logo && !preview && <img src={dddLogo} alt="" className={classes.logo} />}
      {domain===Domain.EInvoices && !logo && !preview && <img src={eLogo} alt="" className={classes.logo} style={{width:"150px"}}/>}
      {(logo||preview) && <img src={process.env.REACT_APP_ORIGIN ? process.env.REACT_APP_ORIGIN+"/"+logo : logo} alt="" className={classes.logo} />}
      </>);
};

export default Logo;
